import { Drawer, Toolbar, withStyles } from "@material-ui/core/";
import { default as MaterialAppBar } from "@material-ui/core/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import TableauReportContainer from "features/analiticopdf/views/tableauReportContainer";
import Auth from "features/authentication/Auth";
import { Notification } from "features/notification";
import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "recompose";
import * as actions from "../../../redux/actions";
import { MenuNavegacao } from "../../navegacao";
import {
  HelpCenterButton,
  LanguageSelect,
  useHelpCenter,
  useLogoutModal,
  UserDropdown,
} from "../../shared/components";
import LogoProdap from "./logoProdap";
import BenchmarkButton from "features/shared/components/BenchmarkButton";
import { useBenchmark } from "hooks/useBenchmark";

export const AppBar = ({
  classes,
  conteudoCustomizadoAppBar,
  isLogoutModalOpen,
  menuNavegacaoProps = {},
  preventPadding = false,
  selectedClient,
  toggleLogoutModal,
  fazendaSelecionada,
  clienteSelecionado,
  loading,
  notifyError,
  notifySuccess,
  showBenchmarkRedirectButton,
}) => {
  const user = Auth.getSession();

  const isAnalyticsUser = Auth.isAnalyticsUser();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const { handleLogout } = useLogoutModal();
  const { handleGetHelpCenterToken, helpCenterPermissions } = useHelpCenter({
    clientPermissions:
      selectedClient != null
        ? {
            canAccess: selectedClient.AcessaCentralAjuda,
            supportAvailable: selectedClient.LiberadoSuporte,
          }
        : null,
  });

  const { redirectToBenchmark } = useBenchmark();

  const handleRedirectToBenchmark = async () => {
    loading(true);
    const redirectResult = await redirectToBenchmark();
    loading(false);

    if (redirectResult.error) {
      notifyError({
        mensagem: redirectResult.error,
      });
      return;
    }

    notifySuccess({
      mensagem: "Redirecionamento para o Benchmark realizado com sucesso.",
    });
  };

  const handleToggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const rootClass = preventPadding ? classes.rootWithoutPadding : classes.root;

  return (
    <div className={rootClass} data-testid="AppBarCustomizado">
      <MaterialAppBar
        className={classes.materialAppBar}
        position="static"
        color="inherit"
      >
        <Toolbar className={classes.toolbar}>
          <div className={classes.container}>
            <div className={classes.startContent}>
              {!isAnalyticsUser && (
                <MenuIcon
                  color="primary"
                  className={classes.menuIcon}
                  data-testid="menu-icon"
                  onClick={handleToggleDrawer}
                />
              )}

              <div className={classes.logo}>
                <LogoProdap />
              </div>

              <Drawer
                data-testid="navigation-menu-drawer"
                open={isDrawerOpen}
                onClose={handleCloseDrawer}
              >
                <MenuNavegacao
                  abreFechaMenu={handleToggleDrawer}
                  {...menuNavegacaoProps}
                />
              </Drawer>
            </div>

            <div className={classes.middleContent}>
              {conteudoCustomizadoAppBar}
              {showBenchmarkRedirectButton && (
                <BenchmarkButton onClick={handleRedirectToBenchmark} />
              )}
            </div>

            <div className={classes.endContent}>
              <HelpCenterButton
                canAccess={helpCenterPermissions.canAccess}
                onGetToken={handleGetHelpCenterToken}
              />
              <Notification />
              <UserDropdown
                isLogoutModalOpen={isLogoutModalOpen}
                toggleLogoutModal={toggleLogoutModal}
                onLogout={handleLogout}
                userName={user.nome || ""}
              />
              <div className={classes.verticalRule} />
              <LanguageSelect />
            </div>
          </div>
        </Toolbar>
      </MaterialAppBar>

      <TableauReportContainer usuario={user} />
    </div>
  );
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.props.tamanhoAppBarXs,
  },
  rootWithoutPadding: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.props.tamanhoAppBarXs,
  },
  materialAppBar: {
    position: "fixed",
    top: 0,
    boxShadow: "none",
  },
  menuIcon: {
    cursor: "pointer",
  },
  startContent: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  logo: {
    display: "flex",
    alignItems: "center",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  middleContent: {
    alignItems: "center",
    flexBasis: "0%",
    flexDirection: "row",
    flexGrow: 1,
    flexShrink: 1,
    display: "flex",
    gap: "12px",
    justifyContent: "center",
  },
  endContent: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    justifyContent: "flex-end",
    "@media (max-width: 720px)": {
      justifyContent: "flex-start",
    },
  },
  verticalRule: {
    borderLeft: "1px solid #EEEEEE",
    height: "20px",
  },
  toolbar: {
    minHeight: "75px",
  },
});

const mapStateToProps = (state) => ({
  fazendaSelecionada: state.fazenda.currentFarm,
  clienteSelecionado: state.cliente.ClienteSelecionado,
  isLogoutModalOpen: state.modal.ModalLogoutAberto,
  showBenchmarkRedirectButton: state.benchmark.loggedUserHasContextualAccess,
});

const mapDispatchToProps = {
  toggleLogoutModal: actions.setModalLogout,
  notifySuccess: actions.notifySuccess,
  notifyError: actions.notifyError,
  loading: actions.exibirCarregando,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(AppBar);
